// extracted by mini-css-extract-plugin
export default {"image":"h4-z","loaded":"i4-z"};